/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { RunAdminCompetitionActionResponse, RunAdminCompetitionActionVars } from '../openapi-types.gen.js';

export type { RunAdminCompetitionActionResponse, RunAdminCompetitionActionVars } from '../openapi-types.gen.js';

export const useRunAdminCompetitionAction = createMutationHook<RunAdminCompetitionActionVars, RunAdminCompetitionActionResponse, unknown>({
  specName: 'useRunAdminCompetitionAction',
  path: '/v1/admin/competitions/{competitionId}/actions/{action}',
  method: 'POST',
  resolveUrl: (vars: RunAdminCompetitionActionVars) => `/v1/admin/competitions/${vars.competitionId}/actions/${vars.action}`,
  
  parseResponse: (raw: unknown): RunAdminCompetitionActionResponse => raw as RunAdminCompetitionActionResponse,
  optimistic: [{
    queryKey: ['admin', 'detail'],
    apply: (prev: any, vars: RunAdminCompetitionActionVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }],
  
  
});
